import UserLoginScreen from './login';
import UserResetPasswordScreen from './reset-password';

export const UserLogin = UserLoginScreen;
export { UserLoginScreen };
export const UserResetPassword = UserResetPasswordScreen;
export { UserResetPasswordScreen };
